<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="注文詳細"
          icon="order"
          class="order-header" />
      <BaseBackButton
          :is-show="showBackButton"
          :return-destination="'/order'" />
      <BaseDetailMoveData
          :id="orderDetail.orderNo"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="orderList"
          :path-parameter="['node.site.code', 'node.orderNo']"
          :can-move-data="canMoveData"
          title="注文番号"
          router-path="/order/" />
      <span class="headerMessage">
        注文修正禁止時間帯：10:00-10:15、22:00-22:15
      </span>
      <span class="action_button">
        <el-dropdown
            v-show="showActionButton"
            @command="actionCommand">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                v-show="showEditOrderButton"
                :disabled="disableEditOrderButton"
                :command="define.ORDER_MODE.EDIT">
              注文修正
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showShortageButton"
                :disabled="disableShortageButton"
                :command="define.ORDER_MODE.SHORTAGE">
              再送
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showExchangeButton"
                :disabled="disableExchangeButton"
                :command="define.ORDER_MODE.EXCHANGE">
              交換出荷
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showReceivedRegisterButton"
                :disabled="disableReceivedRegisterButton"
                :command="define.ORDER_MODE.RECEIVED">
              返品登録
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showCaptureButton"
                :disabled="disableCaptureButton"
                :command="define.ORDER_MODE.CAPTURE">
              手動決済
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showShipmentRegisterButton"
                :disabled="disableShipmentRegisterButton"
                :command="define.ORDER_MODE.SHIPMENT">
              配送先登録
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showOrderCancelButton"
                :disabled="disableOrderCancelButton"
                :command="define.ORDER_MODE.CANCEL">
              一括取消
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showOpluxButton"
                command="OPLUX">
              O-Plux
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <BaseButton
            v-show="showSaveButton"
            @click="cancel">
          キャンセル
        </BaseButton>
        <BaseButton
            v-show="showSaveButton"
            :disabled="!isChanged"
            @click="save">
          保存
        </BaseButton>
      </span>
    </el-row>
    <div class="detail-tab-pager">
      <BaseButton
          :disabled="previousOrderHistory"
          icon="el-icon-d-arrow-left"
          @click="moveOrderHistory(1)" />
      <h4>更新履歴（{{ historiesLen - this.orderIndex }} / {{ historiesLen + 1 }}）</h4>
      <BaseButton
          :disabled="nextOrderHistory"
          icon="el-icon-d-arrow-right"
          @click="moveOrderHistory(-1)" />
    </div>
    <el-tabs
        v-model="activeTabName"
        type="border-card">
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.ORDER_INFO)"
          name="orderInfoPanel">
        <span slot="label"><i class="fas fa-shopping-cart fa-lg" /> 注文情報</span>
        <div>
          <el-collapse
              v-model="activeCollapseName"
              class="orderdetail-collapse"
              @change="collapseChange">
            <el-row :gutter="40">
              <el-col :span="24">
                <el-collapse-item
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.BASIC_INFO)"
                    id="basicInfo"
                    title="基本情報"
                    name="basicInfo">
                  <el-row>
                    <el-col :span="24">
                      <AttributeButton
                          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.ATTRIBUTE)"
                          class="attribute-button"
                          :site-code="siteCode"
                          :editable="editableAttribute"
                          :attribute-values="attributes"
                          page-name="order_detail"
                          area-name="basic_info" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <BaseTableDetail
                          :table-set-list="basicInfo1"
                          :display-item="orderDetail"
                          :editable="editable"
                          :site-code="siteCode"
                          validate-scope="basicInfo" />
                    </el-col>
                    <el-col :span="12">
                      <BaseTableDetail
                          :table-set-list="basicInfo2"
                          :display-item="orderDetail"
                          :editable="editable"
                          :site-code="siteCode"
                          validate-scope="basicInfo" />
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="12">
                <el-collapse-item
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ORDERER_INFO)"
                    id="orderInfo"
                    title="注文者"
                    name="orderInfo">
                  <BaseTableDetail
                      :table-set-list="orderInfo1"
                      :display-item="orderDetail"
                      :editable="editable"
                      :site-code="siteCode"
                      validate-scope="orderInfo" />
                </el-collapse-item>
              </el-col>
            </el-row>
            <el-row v-for="(shipment, i) in orderDetail.shipments"
                :key="`shipment-${i}`"
                :gutter="40">
              <el-col :span="24">
                <el-collapse-item
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.SHIPMENT_INFO) ||
                      $isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ITEM_DETAIL)"
                    :id="`shipment-${i}`"
                    :title="`配送先${i + 1} (配送番号： ${shipment.shipmentId})`"
                    :name="`shipment-${i}`">
                  <OrderDetailShipment
                      ref="OrderDetailShipment"
                      :shipment="shipment"
                      :origin-data="originData"
                      :mode="mode"
                      :validate-scope="`shipInfo-${i}`"
                      :expand-shipment-info.sync="expandShipmentInfo[`shipment-${i}-shipmentInfo`]" />
                </el-collapse-item>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8"
                  :offset="16">
                <el-collapse-item
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.POINT)"
                    id="orderPoint"
                    title="ポイント"
                    name="orderPoint">
                  <BaseTableDetail
                      :table-set-list="orderPoint"
                      :display-item="orderDetail"
                      :editable="editable"
                      :site-code="siteCode"
                      validate-scope="orderPoint" />
                </el-collapse-item>
              </el-col>
            </el-row>
            <el-row id="total-price"
                :gutter="40">
              <el-col :span="12"
                  :offset="12">
                <OrderDetailItems
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.TOTAL_DETAIL)"
                    :order-detail="orderDetail"
                    :origin-data="originData"
                    :mode="mode"
                    title="小計後値引 / 注文合計金額"
                    type="total"
                    validate-scope="orderDetail"
                    class="table" />
              </el-col>
            </el-row>
            <el-row id="paymentType"
                :gutter="40">
              <el-col :span="18"
                  :offset="6">
                <!-- TODO
                  v-if="createCompleted" で OrderDetailPaymentType の生成を遅延させている。
                  遅延させなかった場合、一覧の"手動決済"時に OrderDetailPaymentTypeRow で paymentCooperation を 1 に更新してから
                  $_ConfirmDiscardOnLeave_watchStart するため、[保存]ボタンが有効にならない
                -->
                <OrderDetailPaymentType
                    v-if="createCompleted"
                    v-show="$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.PAYMENT_TYPE_BREAKDOWN)"
                    :origin-data="originData"
                    :mode="mode"
                    validate-scope="paymentType"
                    class="table orderdetail-payments" />
              </el-col>
            </el-row>
            <template v-if="showDetailItemsReceivedTable">
              <el-row :gutter="40">
                <el-col :span="18"
                    :offset="6">
                  <OrderDetailReceivedItems
                      :origin-data="originData"
                      class="table orderdetail-received-items" />
                </el-col>
              </el-row>
            </template>
            <template v-if="showDetailItemsOriginTable">
              <el-row v-for="(shipment, i) in originData.shipments"
                  :key="`origin-shipment-${i}`"
                  :gutter="40">
                <el-col :span="24">
                  <el-collapse-item
                      :title="`変更前配送先${i + 1} (配送番号： ${shipment.shipmentId})`"
                      :name="`origin-shipment-${i}`">
                    <OrderDetailShipment
                        :shipment="shipment"
                        :order-detail="cloneOrigin()"
                        :origin-data="originData"
                        :mode="mode"
                        type="origin" />
                  </el-collapse-item>
                </el-col>
              </el-row>
            </template>
          </el-collapse>
        </div>
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.NOTE)"
          name="notePanel">
        <span slot="label">
          <i class="fas fa-comment-dots fa-lg" />
          メモ
          <el-badge
              class="orderdetail-tab-badge"
              type="info"
              :value="memoCount"
              :max="9"
              :hidden="hideMemoBadge" />
        </span>
        <div>
          <BaseTableList
              :table-set-list="noteList"
              :display-items="sortedNotes"
              :show-index-column="true">
            <template
                slot="operation"
                slot-scope="{ row }">
              <BaseOperationTooltip
                  :list="getNoteTooltipList(row.row, row.$index)"
                  placement="bottom-end" />
            </template>
          </BaseTableList>
          <el-row :gutter="40">
            <el-col :span="12">
              <div class="box orderdetail-note-box">
                <div class="box-header">
                  <label>メモ</label>
                </div>
                <div class="box-inner">
                  <div class="mb10 orderdetail-note-subject-area">
                    <BaseValidInput
                        v-model="noteInfo.subject"
                        name="orderdetail-note-subject"
                        placeholder="件名"
                        class="orderdetail-note-subject" />
                    <div v-if="noteInfo.changingNoteNumber"
                        class="orderdetail-note-info">
                      {{ `(No.${noteInfo.changingNoteNumber} 修正中)` }}
                    </div>
                  </div>
                  <BaseValidInput
                      v-model="noteInfo.note"
                      name="orderdetail-note-content"
                      type="textarea"
                      placeholder="内容" />
                  <div class="orderdetail-note-btn right">
                    <BaseButton
                        @click="clearNote">
                      クリア
                    </BaseButton>
                    <BaseButton
                        :disabled="disableNoteRegister"
                        @click="saveNote">
                      保存
                    </BaseButton>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.LOG)"
          name="logPanel">
        <span slot="label"><i class="fas fa-history fa-lg" /> 更新履歴</span>
        <OrderDetailLogs :latest-order="originData" />
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.EXPORT_AND_SHIPPED)"
          name="ExportAndShippedPanel">
        <span slot="label"><i class="fas fa-truck-moving fa-lg" /> 指図・出荷</span>
        <OrderDetailExportAndShipped
            :mode="mode"
            :export-data="originData.exports"
            :shipped-data="originData.shippeds"
            :changing-note="noteInfo.uuid != null && noteInfo.uuid !== ''"
            @requestUpdate="() => getDetailData({ updateList: true })" />
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.PAYMENT_SET)"
          name="paymentSetPanel">
        <span slot="label">
          <i class="fas fa-credit-card fa-lg" />
          支払処理結果
          <el-badge
              class="orderdetail-tab-badge"
              :value="paymentSetErrorCount"
              :max="9"
              :hidden="hidePaymentSetBadge" />
        </span>
        <OrderDetailPaymentSet
            :mode="mode"
            :payment-sets="originData.paymentSets"
            validate-scope="paymentSet"
            @initByMode="initByMode"
            @requestUpdate="() => getDetailData({ updateList: true })" />
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.MAIL)"
          name="mailPanel">
        <span slot="label"><i class="fas fa-envelope-open fa-lg" /> メール送信履歴</span>
        <OrderDetailMails :order-mails="originData.mail" />
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Order.Detail.COOPERATE)"
          name="cooperatePanel">
        <span slot="label"><i class="fas fa-history fa-lg" /> API実行履歴</span>
        <OrderDetailCooperates :order-cooperates="originData.cooperate" />
      </el-tab-pane>
    </el-tabs>

    <!-- O-Pluxイベント更新 -->
    <OpluxDialog
        :oplux-data="opluxData"
        :visible.sync="isOpluxDialog"
        @requestUpdate="() => getDetailData({ updateList: true })" />
  </div>
</template>

<style scoped>
.headerMessage {
  color: red;
}
.orderdetail-tab-badge {
  position: absolute;
}
.orderdetail-tab-badge >>> .el-badge__content {
  position: relative;
  top: -7px;
  right: 0px;
  border: 0;
}
.attribute-button {
  padding-left: 15px;
}
</style>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'

import * as define from '@/define'
import * as config from '@/config'
import common from '@/utils/common'
import math from '@/utils/math'
import message from '@/utils/message'
import auth from '@/utils/auth'
import compare from '@/utils/compareUtils'

import BaseButton from '@/components/atoms/BaseButton'
import BaseValidInput from '@/components/atoms/BaseValidInput'

import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseDetailMoveData from '@/components/molecules/BaseDetailMoveData'
import BaseTableList from '@/components/molecules/BaseTableList'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'

import OrderDetailPaymentType from '@/components/pages/order/OrderDetailPaymentType'
import OrderDetailExportAndShipped from '@/components/pages/order/OrderDetailExportAndShipped'
import OrderDetailPaymentSet from '@/components/pages/order/OrderDetailPaymentSet'
import OrderDetailShipment from '@/components/pages/order/OrderDetailShipment'
import OrderDetailItems from '@/components/pages/order/OrderDetailItems'
import OrderDetailReceivedItems from '@/components/pages/order/OrderDetailReceivedItems'
import OrderDetailLogs from '@/components/pages/order/OrderDetailLogs'
import OrderDetailMails from '@/components/pages/order/OrderDetailMails'
import OrderDetailCooperates from '@/components/pages/order/OrderDetailCooperates'
import OpluxDialog from '@/components/pages/order/OpluxDialog'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import orderUtil from '@/components/mixins/orderUtil'
import detailUtil from '@/components/mixins/detailUtil'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

import AttributeButton from '@/components/organisms/AttributeButton'

const EDITABLE = Object.freeze({
  [define.ORDER_MODE.EDIT]: Object.freeze({
    orderName: true, orderNameKana: true, orderTel: true, orderAddress: true,
    point: true, consumedPoint: true
  }),
  [define.ORDER_MODE.SHORTAGE]: Object.freeze({
    orderName: true, orderNameKana: true, orderTel: true, orderAddress: true,
    point: true, consumedPoint: true
  }),
  [define.ORDER_MODE.RECEIVED]: Object.freeze({
    point: true, consumedPoint: true
  }),
  [define.ORDER_MODE.EXCHANGE]: Object.freeze({
    point: true, consumedPoint: true
  })
})

const WATCH_TARGET_PA = ['merchandisePriceAdjustments']
const WATCH_TARGET_PP = ['payments']

// 消費ポイント
const POINT_TARGET_POINT = '1'
// 獲得ポイント
const POINT_TARGET_CONSUMED_POINT = '2'
// 全て対象外
const POINT_TARGET_NONE = '99'

const returnDestination = '/order'

export default {
  name: 'OrderDetail',
  components: {
    BaseButton,
    BaseValidInput,
    BaseHeader,
    BaseOperationTooltip,
    BaseBackButton,
    BaseDetailMoveData,
    BaseTableList,
    BaseTableDetail,
    OrderDetailPaymentType,
    OrderDetailExportAndShipped,
    OrderDetailPaymentSet,
    OrderDetailShipment,
    OrderDetailItems,
    OrderDetailReceivedItems,
    OrderDetailLogs,
    OrderDetailMails,
    OrderDetailCooperates,
    OpluxDialog,
    AttributeButton
  },
  mixins: [ x, confirmDiscardOnLeave, orderUtil, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      activeTabName: '',
      activeCollapseName: [],
      isChanged: false,
      originData: { histories: [] }, // Computed error回避 (OPEN 時点で histories がないので error が表示される)
      orderIndex: -1, // 表示中の注文情報のポジション(histories)
      // TODO メモコンポーネントを作成し、移動する。
      noteInfo: {
        subject: '',
        note: '',
        uuid: '',
        noteType: 2,
        changingNoteNumber: undefined
      },
      extraExportDisplayItems: [],
      createCompleted: false,
      expandShipmentInfo: {},
      canMoveData: false,
      isOpluxDialog: false,
      opluxData: { node: {} },
      watchFlg: true
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.Order.listIndex,
      tableSetList: (state) => state.Order.tableSetList,
      currentPage: (state) => state.Order.currentPage,
      size: (state) => state.Order.size,
      mode: (state) => state.Order.mode,
      returnList: (state) => state.Order.returnList,
      sites: (state) => state.sites
    }),
    ...mapGetters({
      orderPointConfigCancel: 'orderPointConfigCancel',
      allowOverFirstTotalAmount: 'allowOverFirstTotalAmount',
      allowSameSku: 'allowSameSku',
      allowPartialShipment: 'allowPartialShipment',
      useMail: 'useMail',
      needConfirm: 'needConfirm',
      getOrderPointConfig: 'getOrderPointConfig',
      getPointAdjustmentConfig: 'getPointAdjustmentConfig',
      orderPointConfigPointTarget: 'orderPointConfigPointTarget'
    }),
    ...mapGetters('OrderDetail', {
      orderDetail: 'orderDetail',
      siteCode: 'siteCode',
      orderDatetime: 'orderDatetime',
      orderDetailItems: 'items',
      orderDetailGiftItems: 'giftItems',
      orderDetailShippingItems: 'shippingItems',
      taxInfo: 'taxInfo',
      paymentSetErrorCount: 'paymentSetErrorCount'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    storePath () {
      return 'Order'
    },
    sortedList () {
      return this.$store.getters['sortedList'](this.storePath, this.sortCondition('orderList'))
    },
    // Detail Table 構成定義
    basicInfo1 () {
      return [
        {
          label: 'サイト',
          properties: [
            { path: 'site.code', type: 'String', codeName: 'sites',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.SITE }
          ]
        },
        {
          label: '注文日時',
          properties: [
            { path: 'orderDatetime', type: 'Date',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.ORDER_DATETIME }
          ]
        },
        {
          label: '注文種類',
          properties: [
            { path: 'orderType', type: 'String', editableId: 'orderType',
              selectCode: 'd_order.order_type', codeName: 'd_order.order_type',
              elementType: ELEMENT_TYPE.SELECT_BOX,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.ORDER_TYPE }
          ]
        },
        {
          label: '支払方法',
          properties: [
            { path: this.paymentMethod, type: 'String', elementType: ELEMENT_TYPE.TAG, size: 'small',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.PAYMENT_METHOD }
          ]
        }
      ]
    },
    basicInfo2 () {
      return [
        {
          label: '注文ステータス',
          properties: [
            { path: this.orderStatus, type: 'String', elementType: ELEMENT_TYPE.TAG, size: 'small',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.ORDER_STATUS }
          ]
        },
        {
          label: '支払ステータス',
          properties: [
            { path: 'isPaid', type: 'String', codeName: 'd_order.is_paid',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.IS_PAID }
          ]
        },
        {
          label: '不正検知審査結果',
          properties: [
            { path: 'redResult', codeName: 'd_order.red_result', colsep: `
            `, lineBreak: true, funcId: define.PermissionKeys.Order.List.RED_RESULT
            }
          ]
        },
        {
          label: '利用ポイント',
          properties: [
            { path: 'consumedPoint', type: 'String', codeName: 'd_order.consumed_point',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.CONSUMED_POINT }
          ]
        }
      ]
    },
    orderInfo1 () {
      return [
        {
          label: '注文者氏名',
          properties: [
            {
              path: 'orderer.lastName', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderName', editableCondition: this.orderInfoEditableCondition,
              validateRule: 'checkOrdererName:true',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.NAME
            }, {
              path: 'orderer.firstName', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderName', editableCondition: this.orderInfoEditableCondition,
              validateRule: 'checkOrdererName',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.NAME
            }
          ],
          horizontal: true
        },
        {
          label: '氏名カナ',
          properties: [
            {
              path: 'orderer.lastNameKana', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderNameKana', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.NAME_KANA
            }, {
              path: 'orderer.firstNameKana', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderNameKana', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.NAME_KANA
            }
          ],
          horizontal: true
        },
        {
          label: '注文者TEL',
          properties: [
            {
              path: 'orderer.phone', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderTel', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.TEL
            }
          ]
        },
        {
          label: '〒',
          properties: [
            {
              path: 'address.postalCode', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.POSTAL_CODE
            }
          ]
        },
        {
          label: '都道府県',
          properties: [
            {
              path: 'address.stateCode', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.STATE
            }
          ]
        },
        {
          label: '市区町村',
          properties: [
            {
              path: 'address.city', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.CITY
            }
          ]
        },
        {
          label: '住所1',
          properties: [
            {
              path: 'address.address1', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.ADDRESS_1
            }
          ]
        },
        {
          label: '住所2',
          properties: [
            {
              path: 'address.address2', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.ADDRESS_2
            }
          ]
        },
        {
          label: '建物名・部屋番号',
          properties: [
            {
              path: 'address.suite', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderAddress', editableCondition: this.orderInfoEditableCondition,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.SUITE
            }
          ]
        },
        {
          label: 'メールアドレス',
          properties: [
            {
              path: 'customerEmail', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'orderMail', editableCondition: this.orderInfoEditableCondition,
              showCopyButton: true,
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.EMAIL
            }
          ]
        },
        {
          label: '顧客番号',
          properties: this.mode === define.ORDER_MODE.NORMAL &&
            !this.$isFunctionDisabled(define.PermissionKeys.Customer.DETAIL) ? [
              {
                path: 'customerNo', type: 'String',
                funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.CUSTOMER_NUMBER,
                linkKey: 'customer.uuid', linkPath: '/customer/', elementType: ELEMENT_TYPE.LINK,
                onLinkClick: (key, keyPath) => {
                  this.$_mixin_onLinkClick(-1, 'Customer')
                }
              }
            ] : [
              {
                path: 'customerNo', type: 'String',
                funcId: define.PermissionKeys.Order.Detail.OrderInfo.OrdererInfo.CUSTOMER_NUMBER
              }
            ]
        }
      ]
    },
    orderPoint () {
      return [
        {
          label: '獲得ポイント',
          properties: [
            {
              path: 'point', type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER,
              editableId: 'point', class: 'right',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.point.POINT
            }
          ]
        },
        {
          label: '消費ポイント',
          properties: [
            {
              path: 'consumedPoint', type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER,
              editableId: 'consumedPoint', class: 'right',
              funcId: define.PermissionKeys.Order.Detail.OrderInfo.point.CONSUMED_POINT,
              change: (event) => { this.consumedPointChange(event) }
            }
          ]
        }
      ]
    },
    sortedNotes () {
      return _.chain(this.originData)
        .get('notes')
        .orderBy(['createdAt'], ['desc'])
        .value()
    },
    noteList () {
      return [
        { type: 'Date', label: '登録日時', path: 'createdAt', width: '200',
          funcId: define.PermissionKeys.Order.Detail.Note.CREATED_AT },
        { type: 'Date', label: '更新日時', path: 'updatedAt', width: '200',
          funcId: define.PermissionKeys.Order.Detail.Note.UPDATE_AT },
        { type: 'String', label: '件名', path: 'subject', width: '250',
          funcId: define.PermissionKeys.Order.Detail.Note.SUBJECT },
        { type: 'String', label: '内容', path: 'note', lineBreak: true },
        { type: 'Slot', label: '', path: 'operation', width: 80, class: 'center',
          isShow: this.$isFunctionShown(define.PermissionKeys.Order.Detail.Note.EDIT) ||
            this.$isFunctionShown(define.PermissionKeys.Order.Detail.Note.DELETE) }
      ]
    },
    orderList () {
      if (this.returnList) {
        return []
      } else {
        return this.sortedList
      }
    },
    // 次の注文履歴情報ボタン制御
    nextOrderHistory () {
      if (this.mode === define.ORDER_MODE.NORMAL) {
        return this.orderIndex === -1
      } else {
        return true
      }
    },
    // 前の注文履歴情報ボタン制御
    previousOrderHistory () {
      if (this.mode === define.ORDER_MODE.NORMAL) {
        return this.originData.histories.length <= this.orderIndex + 1
      } else {
        return true
      }
    },
    // 注文履歴の数を返却します。
    historiesLen () {
      return this.originData.histories.length
    },
    showEditOrderButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.EDIT)
    },
    disableEditOrderButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isEditableByQty(this.orderDetailItems) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.EDIT)
    },
    showShortageButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.SHORTAGE)
    },
    disableShortageButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isShortageShippableByQty(this.orderDetailItems) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.SHORTAGE)
    },
    showExchangeButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.EXCHANGE)
    },
    disableExchangeButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isExchangeableByQty(this.orderDetailItems) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.EXCHANGE)
    },
    showReceivedRegisterButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.RECEIVED)
    },
    disableReceivedRegisterButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isReceivedFixableByQty(this.orderDetailItems) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.RECEIVED)
    },
    showCaptureButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.CAPTURE)
    },
    disableCaptureButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isCapturable(this.orderDetail.payments, this.orderDetail.paymentSets) ||
              this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.CAPTURE)
    },
    showShipmentRegisterButton () {
      return ![define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.RECEIVED, define.ORDER_MODE.SHIPMENT].includes(this.mode) &&
              this.$isFunctionShown(define.PermissionKeys.Order.Detail.SHIPMENT)
    },
    disableShipmentRegisterButton () {
      return !this.orderDetail.isLatest || this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.SHIPMENT)
    },
    showOrderCancelButton () {
      return this.showActionButton && this.$isFunctionShown(define.PermissionKeys.Order.Detail.CANCEL)
    },
    disableOrderCancelButton () {
      return !this.orderDetail.isLatest || !this.$_orderUtil_isCancellableByQty(this.orderDetailItems) || this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.CANCEL)
    },
    showOpluxButton () {
      return this.$isFunctionShown(define.PermissionKeys.Order.Detail.OPLUX) && this.isEableOplux
    },
    disableNoteRegister () {
      return ![define.ORDER_MODE.NORMAL].includes(this.mode) ||
        this.noteInfo.subject == null || this.noteInfo.subject === '' ||
        this.noteInfo.note == null || this.noteInfo.note === '' ||
        (!this.noteInfo.uuid && this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.Note.NEW)) ||
        (Boolean(this.noteInfo.uuid) && this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.Note.EDIT))
    },
    showBackButton () {
      return this.showActionButton && !this.$isFunctionDisabled(define.PermissionKeys.Order.LIST)
    },
    showActionButton () {
      return [define.ORDER_MODE.NORMAL, define.ORDER_MODE.CANCEL].includes(this.mode)
    },
    showSaveButton () {
      return !this.showActionButton
    },
    editable () {
      return EDITABLE[this.mode] || {}
    },
    showDetailItemsReceivedTable () {
      return [define.ORDER_MODE.RECEIVED].includes(this.mode)
    },
    showDetailItemsOriginTable () {
      return [define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.RECEIVED].includes(this.mode)
    },
    addableShipmentTab () {
      return [define.ORDER_MODE.SHIPMENT].includes(this.mode)
    },
    editableAttribute () {
      return !this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.OrderInfo.BasicInfo.Attribute.ATTRIBUTE_EDIT) &&
        [define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.EXCHANGE].includes(this.mode)
    },
    noTaxInfo () {
      return this.taxInfo == null
    },
    activeCollapseKey () {
      return 'orderDetailCollapse'
    },
    memoCount () {
      return _.chain(this.originData).get('notes').size().value()
    },
    hideMemoBadge () {
      return this.memoCount === 0
    },
    hidePaymentSetBadge () {
      return this.paymentSetErrorCount === 0
    },
    defaultDispTab () {
      // タブの表示権限を見て、最左のものを選択する。
      if (this.$isFunctionShown(define.PermissionKeys.Order.Detail.ORDER_INFO)) {
        return 'orderInfoPanel'
      } else if (this.$isFunctionShown(define.PermissionKeys.Order.Detail.NOTE)) {
        return 'notePanel'
      } else if (this.$isFunctionShown(define.PermissionKeys.Order.Detail.LOG)) {
        return 'logPanel'
      } else if (this.$isFunctionShown(define.PermissionKeys.Order.Detail.EXPORT_AND_SHIPPED)) {
        return 'ExportAndShippedPanel'
      } else if (this.$isFunctionShown(define.PermissionKeys.Order.Detail.PAYMENT_SET)) {
        return 'paymentSetPanel'
      } else {
        return ''
      }
    },
    isCreatedCaputure () {
      // 決済処理が必要な支払処理
      const requireCaputurePayment = _.filter(this.orderDetail.payments, payment => {
        return payment.isProcessed === 1 && payment.isPaid === 0 && +payment.amount > 0
      })
      // 未出荷完了状態の明細
      const inComletedItems = _.flatten(_.map(this.orderDetail.shipments, shipment => {
        return _.filter(shipment.items, item => {
          return +item.qty.unallocated !== 0 ||
          +item.qty.pending !== 0 ||
          +item.qty.preExport !== 0 ||
          +item.qty.preReExport !== 0 ||
          +item.qty.exported !== 0 ||
          +item.qty.unshipped !== 0
        })
      }))
      return requireCaputurePayment.length > 0 && inComletedItems.length === 0
    },
    /**
     * O-PLUXボタン
     * @return {Boolean} イベントIDが存在する場合は true
     */
    isEableOplux: function () {
      const redEventId = _.keyBy((this.orderDetail || []).attributes, 'attrId').redEventId
      return redEventId || false
    },
    attributes () {
      return _.get(this.orderDetail, 'attributes', [])
    },
    filteredPA () {
      return JSON.parse(JSON.stringify(_.pick(this.orderDetail, WATCH_TARGET_PA)))
    },
    filteredPP () {
      return JSON.parse(JSON.stringify(_.pick(this.orderDetail, WATCH_TARGET_PP)))
    }
  },
  watch: {
    orderDetail: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    'orderDetail.orderer.lastName' () {
      this.validateOrderInfo()
    },
    'orderDetail.orderer.firstName' () {
      this.validateOrderInfo()
    },
    filteredPP: {
      // ポイント支払の変更を検知
      handler (newVal, oldVal) {
        if (!this.watchFlg ||
          ![define.ORDER_MODE.EDIT,
            define.ORDER_MODE.SHORTAGE,
            define.ORDER_MODE.EXCHANGE,
            define.ORDER_MODE.RECEIVED].includes(this.mode)) {
          this.watchFlg = true
          return
        }
        // is_point =1の対象を抽出
        // 変更後情報
        const newData = _.find(newVal.payments, { paymentMethod: { isPoint: 1 } })
        // 変更前情報
        const oldData = _.find(oldVal.payments, { paymentMethod: { isPoint: 1 } })
        let beforeAmount = 0
        let afterAmount = 0
        if (oldData) {
          beforeAmount = oldData.amount
        }
        if (newData) {
          afterAmount = newData.amount
        }
        // ポイント支払の金額が変わった場合
        if (beforeAmount !== afterAmount) {
          // 消費ポイントに金額を設定するを行う
          this.detailPointChange(afterAmount, 'pointPay')
        }
      },
      deep: true
    },
    filteredPA: {
      // ポイント値引の変更を検知
      handler (newVal, oldVal) {
        if (!this.watchFlg ||
          ![define.ORDER_MODE.EDIT,
            define.ORDER_MODE.SHORTAGE,
            define.ORDER_MODE.EXCHANGE,
            define.ORDER_MODE.RECEIVED].includes(this.mode)) {
          this.watchFlg = true
          return
        }
        // is_point =1の対象を抽出
        // 変更後情報
        const newData = _.find(newVal.merchandisePriceAdjustments,
          val => !val.delete && val.isPoint === 1)
        // 変更前情報
        const oldData = _.find(oldVal.merchandisePriceAdjustments,
          val => !val.delete && val.isPoint === 1)
        let beforeAmount = 0
        let afterAmount = 0
        if (oldData) {
          beforeAmount = oldData.price.gross
        }
        if (newData) {
          afterAmount = newData.price.gross
        }
        // ポイント支払の金額が変わった場合
        if (beforeAmount !== afterAmount) {
          // 消費ポイントに金額を設定するを行う
          this.detailPointChange(afterAmount, 'priceAdj')
        }
      },
      deep: true
    },
    expandShipmentInfo: {
      handler: function (val) {
        // 配送情報の展開状態をLocalStorageに保存する
        _.chain(val)
          .forEach((val, key) => {
            const index = _.indexOf(this.activeCollapseName, key)
            if (val && index === -1) {
              this.activeCollapseName.push(key)
            } else if (!val && index !== -1) {
              this.activeCollapseName.splice(index, 1)
            }
          })
          .value()
        this.collapseChange()
      },
      deep: true
    }
  },
  async created () {
    // TODO 暫定対応。名のエラーメッセージを消して同じメッセージが表示されないようにしている
    // TODO 配送先情報にも同様のvalidatorがある。共通化できないか要検討。
    this.$validator.extend('checkOrdererName', {
      getMessage: (field, [ target ]) => target ? '姓、または名は必須です。' : ' ',
      validate: (field, args) => {
        return {
          valid: _.chain(this.orderDetail)
            .get('orderer')
            .thru(val => [_.get(val, 'lastName', ''), _.get(val, 'firstName', '')])
            .map(val => _.trim(val))
            .find(val => val !== '')
            .value() != null,
          data: {
            required: true
          }
        }
      }
    }, {
      computesRequired: true
    })

    this.activeTabName = this.defaultDispTab

    window.addEventListener('beforeunload', this.onBeforeUnload)
    try {
      this.$loadingService.show()
      const param = this.$route.params.id
      const i = param.indexOf('&')
      const siteCode = param.substr(0, i)
      const orderNo = param.substr(i + 1)

      await this.fetchOrderDatetime({ siteCode, orderNo })
      await this.getDetailData({ siteCode, orderNo })
      await this.fetchTaxInfo({
        siteCode: this.siteCode,
        baseDateTime: this.orderDetail.orderDatetime,
        type: define.TAX_RATE_TYPE.NORMAL
      })

      if (this.mode !== define.ORDER_MODE.NORMAL &&
          Vue.moment(this.sortedList[this.listIndex].node.lastUpdatedAt).format() < Vue.moment(this.orderDetail.lastUpdatedAt).format()) {
        // 注文情報が更新されている場合、modeを初期化する
        this.$notify.warning('注文情報が更新されています。')
        this.updateMode(define.ORDER_MODE.NORMAL)
      }
      if (this.mode !== define.ORDER_MODE.NORMAL) {
        if (this.noTaxInfo) {
          this.$alert(
            '基本税率情報の取得に失敗したため、注文の修正は行えません。',
            define.MESSAGE_TITLE,
            { type: 'warning', showClose: false }
          )
          this.updateMode(define.ORDER_MODE.NORMAL)
        }
      }

      await this.initByMode(true)
      this.activeCollapseName = _.split(common.getLocalStorage(this.activeCollapseKey), ',')

      // 配送先の配送情報を展開する
      _.chain(this.activeCollapseName)
        .filter(val => /shipment-\d+-shipmentInfo/.test(val))
        .forEach(val => {
          this.$set(this.expandShipmentInfo, val, true)
        })
        .value()

      this.createCompleted = true
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  destroyed () {
    this.setOrderDetail(null)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == null) {
      // 再読み込み時はmodeを初期化する.
      next(vm => {
        vm.updateMode(define.ORDER_MODE.NORMAL)
      })
    } else {
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    // 注文詳細間移動時の処理.
    // modeの初期化とデータの初期化を行う.
    try {
      this.$loadingService.show()
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.updateMode(define.ORDER_MODE.NORMAL)
      const param = to.params.id
      const i = param.indexOf('&')
      const siteCode = param.substr(0, i)
      const orderNo = param.substr(i + 1)

      await this.fetchOrderDatetime({ siteCode, orderNo })
      await this.getDetailData({ siteCode, orderNo })
      await this.fetchTaxInfo({
        siteCode: siteCode,
        baseDateTime: this.orderDatetime,
        type: define.TAX_RATE_TYPE.NORMAL
      })
      next()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、modeを初期化する.
    try {
      this.updateMode(define.ORDER_MODE.NORMAL)
      this.$store.dispatch({
        type: 'set',
        states: {
          'Order/returnList': false
        }
      })
      next()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    }
  },
  methods: {
    ...mapActions('OrderDetail', [
      'fetchOrderDetail',
      'fetchOrderDatetime',
      'fetchTaxInfo',
      'setOrderDetail',
      'calculateTotal'
    ]),
    ...mapMutations('Order', {
      updateListItem: 'update'
    }),
    cloneOrigin () {
      return _.cloneDeep(this.originData)
    },
    /**
     * メモ一覧のTooltipの項目を返却する.
     * @param {Object} row
     * @param {Number} index 0オリジン
     * @return {Array}
     */
    getNoteTooltipList (row, index) {
      return [
        {
          title: '修正',
          disabled: () => this.disableNoteEditAndDelete(row) ||
            this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.Note.EDIT),
          click: (item) => this.editNote(row, index),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.Note.EDIT)
        }, {
          title: '削除',
          disabled: () => this.disableNoteEditAndDelete(row) ||
            this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.Note.DELETE),
          click: (item) => this.deleteNote(row, index),
          show: this.$isFunctionShown(define.PermissionKeys.Order.Detail.Note.DELETE)
        }
      ]
    },
    // メモツールチップ制御
    disableNoteEditAndDelete (row) {
      return row.noteType !== 2 || ![define.ORDER_MODE.NORMAL].includes(this.mode)
    },
    /**
     * 支払方法を返却します。
     * @param {Object} row 注文情報
     */
    paymentMethod (row) {
      if (!row.payments) {
        return []
      }
      return this.$_orderUtil_orderPaymentTag(row.payments)
    },
    /**
     * 注文ステータスを返却します。
     * @param {Object} row 注文情報
     * @returns {Array} tag 生成のための配列
     */
    orderStatus (row) {
      if (!row.qty) {
        return []
      }
      return this.$_orderUtil_headerOrderStatusTag(row)
    },
    /**
     * 詳細な編集可否を判定する
     * @return {Boolean} 編集可否
     */
    orderInfoEditableCondition (row, path) {
      return _.chain(row)
        .get('shipments')
        .flatMap(val => val.items || [])
        .map(val => [_.get(val, 'qty.exported', 0), _.get(val, 'qty.exOutExported', 0)])
        .find(([exported, exOutExported]) => {
          return +exported !== 0 || +exOutExported !== 0
        })
        .value() == null
    },
    /**
     * store のモードを更新します。
     */
    updateMode (mode) {
      this.$store.dispatch({
        type: 'set',
        states: {
          'Order/mode': mode
        }
      })
    },
    /**
     * 注文詳細情報を取得します。
     * @param {Boolean} [updateList=false] 一覧の情報を更新する場合、true.
     * @param {String} siteCode 未設定の場合、現在のrouteから取得する.
     * @param {String} orderNo 未設定の場合、現在のrouteから取得する.
     */
    async getDetailData ({ updateList = false, siteCode, orderNo } = {}) {
      try {
        this.$loadingService.show()
        if (!siteCode || !orderNo) {
          const param = this.$route.params.id
          const i = param.indexOf('&')
          siteCode = param.substr(0, i)
          orderNo = param.substr(i + 1)
        }

        // listIndexの更新
        this.$_detailUtil_onGetDetailData((element) => element.node.site.code === siteCode && element.node.orderNo === orderNo)

        await this.fetchOrderDetail({ siteCode, orderNo, orderDatetime: this.orderDatetime })
        if (_.keys(this.orderDetail).length === 0) {
          // 結果が null の場合
          this.$notify.error({
            message: 'データを取得できませんでした。'
          })
          return
        }
        this.originData = await _.cloneDeep(this.orderDetail)
        this.orderIndex = -1

        if (updateList) {
          this.updateListItem(this.orderDetail)
        }

        // メモ修正中の場合は 修正中状態をクリア
        if (this.noteInfo.uuid) {
          this.$_ConfirmDiscardOnLeave_watchEnd()
          this.noteInfo = {
            subject: '',
            note: '',
            uuid: '',
            noteType: 2,
            changingNoteNumber: undefined
          }
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    /**
     * モードに対応する初期処理を実行します。
     * @param {Boolean} [isInitialize=false] createdから呼ばれた場合、true。
     */
    initByMode (isInitialize = false) {
      this.activeTabName = this.defaultDispTab

      switch (this.mode) {
        case define.ORDER_MODE.EDIT:
        case define.ORDER_MODE.CHANGE_PAYMENT:
          break
        case define.ORDER_MODE.SHORTAGE:
        case define.ORDER_MODE.EXCHANGE:
        case define.ORDER_MODE.RECEIVED:
          let table = document.querySelector('#order-detail-item-table')
          if (table) {
            window.scroll({ top: table.offsetTop, behavior: 'smooth' })
          }
          break
        case define.ORDER_MODE.CAPTURE:
          const paymentType = document.querySelector('#paymentType')
          if (paymentType) {
            window.scroll({ top: paymentType.offsetTop, behavior: 'smooth' })
          }
          break
        case define.ORDER_MODE.SHIPMENT:
          if (!new Set(this.activeCollapseName).has('shipInfo')) {
            this.activeCollapseName.push('shipInfo')
          }
          break
        case define.ORDER_MODE.CANCEL:
          if (this.mode === define.ORDER_MODE.CANCEL && isInitialize) {
            this.orderCancel(true)
          }
          // 以降の処理は不要
          return
        default: // その他は処理を終了
          return
      }

      this.originData = _.cloneDeep(this.orderDetail)
      this.$_ConfirmDiscardOnLeave_watchStart(this.orderDetail)

      if (this.mode === define.ORDER_MODE.SHORTAGE &&
          _.find(this.orderDetailItems, val => _.get(val, 'qty.unshipped', 0) > 0)) {
      // 再送モード かつ 出荷キャンセル がある場合

        // 再送に自動で移動するか確認ダイアログを表示
        this.showConfirmAllShortageShip()

      } else if (this.mode === define.ORDER_MODE.RECEIVED) {
      // 返品登録モードの場合

        // 返品を処理済み返品に移動
        _.chain(this.orderDetailItems)
          .filter(val => this.$_orderUtil_unprocessedReceivedQty(val.qty) > 0)
          .forEach(val => {
            this.$_orderUtil_moveQty(val.qty, val.qty, [ 'receiveShipped' ], 'receiveFixed')
            val.qty.current = this.$_orderUtil_calculateCurrentQty(val.qty)
            // バンドル商品の場合
            if (val.isBundle) {
              _.forEach(val.bundleItems, bVal => {
                this.$_orderUtil_moveQty(bVal.qty, bVal.qty, [ 'receiveShipped' ], 'receiveFixed')
                bVal.qty.current = this.$_orderUtil_calculateCurrentQty(bVal.qty)
              })
            }
          })
          .value()
      }
    },
    /**
     * モードの切替を行います。
     */
    changeMode (mode) {
      this.updateMode(mode)
      this.initByMode()
    },
    /**
     * 通常モードに変更します。
     * 遷移元の画面が指定されている場合は画面を切り替えます。
     */
    changeModeToNormal () {
      this.updateMode(define.ORDER_MODE.NORMAL)
      // returnList が true の場合は遷移先に移動する。
      if (this.returnList) {
        this.$router.push({ path: returnDestination })
      }
    },
    /**
     * 一括取消のリクエストが生成される状態にデータを更新する
     * @param {String} isClearPoint ポイントを0 にするか
     */
    orderCancelUpdate (isClearPoint) {

      // 商品明細 未出荷完了分をキャンセルに移動、金額、ポイントを 0 に更新
      _.forEach(this.orderDetailItems, val => {
        this.$_orderUtil_moveQty(val.qty, val.qty, [ 'unallocated', 'pending', 'preExport' ], 'canceled')
        this.$_orderUtil_moveQty(val.qty, val.qty, [ 'unshipped', 'preReExport' ], 'inshipCanceled')
        val.qty.current = 0
        val.price.gross = 0
        val.price.net = 0
        if (isClearPoint) {
          if (![POINT_TARGET_CONSUMED_POINT, POINT_TARGET_NONE].includes(this.orderPointConfigPointTarget) && val.point > 0) {
            //  2(消費ポイントのみ)、又は 99(全て対象外)以外の場合 且つ 商品明細.消費ポイントが 0でない場合
            // 商品明細ポイントを0にする
            val.point = 0
          }
          if (![POINT_TARGET_POINT, POINT_TARGET_NONE].includes(this.orderPointConfigPointTarget) && val.consumedPoint > 0) {
            //  1(獲得ポイントのみ)、又は 99(全て対象外)以外の場合 且つ 商品明細.獲得ポイントが 0でない場合
            // 注文ポイントを0にする
            val.consumedPoint = 0
          }
        }
        // バンドル構成品の数量も更新
        if (val.isBundle) {
          _.forEach(val.bundleItems, bVal => {
            this.$_orderUtil_moveQty(bVal.qty, bVal.qty, [ 'unallocated', 'pending', 'preExport' ], 'canceled')
            this.$_orderUtil_moveQty(bVal.qty, bVal.qty, [ 'unshipped', 'preReExport' ], 'inshipCanceled')
            bVal.qty.current = 0
          })
        }
      })
      // 商品明細の単品値引単価を0にする
      _.chain(this.orderDetailItems)
        .flatMap(val => val.priceAdjustments)
        .forEach(val => {
          val.price.gross = 0
          val.price.net = 0
        })
        .value()
      // ギフト明細、送料明細、小計値引の単価を0にする（単品値引行含む）
      _.chain([])
        .concat(this.orderDetailGiftItems, this.orderDetailShippingItems, this.orderDetail.merchandisePriceAdjustments)
        .flatMap(val => _.concat([], val, val.priceAdjustments))
        .filter(val => val != null)
        .forEach(val => {
          val.basePrice.gross = 0
          val.basePrice.net = 0
          val.price.gross = 0
          val.price.net = 0
        })
        .value()
      // 注文支払の金額を0にする
      _.chain(this.orderDetail)
        .get('payments')
        .forEach(val => {
          val.amount = 0
        })
        .value()
      // 注文情報.ポイント
      if (isClearPoint) {
        if (!['2', '99'].includes(this.orderPointConfigPointTarget) && this.orderDetail.point > 0) {
          //  2(消費ポイントのみ)、又は 99(全て対象外)以外の場合 且つ 獲得ポイントが 0でない場合
          // 注文ポイントを0にする
          this.orderDetail.point = 0
        }
        if (!['1', '99'].includes(this.orderPointConfigPointTarget) && this.orderDetail.consumedPoint > 0) {
          //  2(消費ポイントのみ)、又は 99(全て対象外)以外の場合 且つ 消費ポイントが 0でない場合
          // 注文ポイントを0にする
          this.orderDetail.consumedPoint = 0
        }
      }
    },
    /**
     * 注文情報更新 API コール用にリクエストを生成します。
     * @return {Object} リクエストボディ
     */
    buildOrderRequest () {
      const requestBody = _.chain(compare.diff(this.originData, this.orderDetail))
        .cloneDeep()
        .pick([
          'orderDatetime', 'customerNo', 'customerEmail', 'customerLocale', 'orderer', 'address',
          'isPaid', 'invoiceNo', 'currency', 'taxation', 'businessType', 'orderType', 'channelType', 'attributes',
          'consumedPoint', 'point'
        ])
        .value()
      this.buildAttributes(requestBody, this.orderDetail)

      const build = (current, origin, children = [], isExchanges = false) => {
        return _.chain(compare.diff(origin, current))
          .cloneDeep()
          .map((val, key) => {
            val.uuid = _.get(current, `${key}.uuid`)
            if (isExchanges) {
              val.srcOrderItem = _.get(current, `${key}.srcOrderItem`)
            }
            for (let i = 0; i < children.length; i++) {
              const child = children[i]
              const childValue = build(
                _.get(current, `${key}.${child.name}`),
                _.get(origin, `${key}.${child.name}`),
                child.children,
                child.name === 'exchanges'
              )
              if (_.size(childValue) > 0) {
                _.set(val, child.name, childValue)
              }
            }
            this.buildAttributes(val, _.get(current, key))
            return val
          })
          .value()
      }

      // 配送先情報
      const shipments = build(
        this.orderDetail.shipments, this.originData.shipments,
        [
          { name: 'items', children: [ { name: 'priceAdjustments' }, { name: 'exchanges' }, { name: 'bundleItems', children: [ { name: 'exchanges' } ] } ] },
          { name: 'giftItems', children: [ { name: 'priceAdjustments' } ] },
          { name: 'shippingItems', children: [ { name: 'priceAdjustments' } ] }
        ])
      if (_.size(shipments) > 0) {
        requestBody.shipments = shipments
      }
      // 小計値引情報
      const merchandisePriceAdjustments = build(
        this.orderDetail.merchandisePriceAdjustments, this.originData.merchandisePriceAdjustments)
      if (_.size(merchandisePriceAdjustments) > 0) {
        requestBody.merchandisePriceAdjustments = merchandisePriceAdjustments
      }
      // 支払情報
      const payments = build(
        this.orderDetail.payments, this.originData.payments)
      if (_.size(payments) > 0) {
        requestBody.payments = payments
      }
      // 支払処理 (支払方法変更時のみ)
      if (this.mode === define.ORDER_MODE.CHANGE_PAYMENT) {
        requestBody.paymentSets = this.orderDetail.paymentSets
      }
      return requestBody
    },
    buildAttributes (request, value) {
      if (!_.has(request, 'attributes')) {
        return
      }
      request.attributes = _.chain(request.attributes)
        .entries()
        .map(([key, val]) => {
          const attrId = _.get(value, `attributes.${key}.attrId`, '')
          return attrId === '' ? null : { attrId: attrId, attrValue: val.attrValue }
        })
        .filter(val => val != null)
        .value()
    },
    /**
     * 注文情報更新 API
     * @param {String} method
     * @param {String} uuid
     * @param {Object} data request body
     */
    async callApiOrderUpdate ({ method = 'put', uuid, data } = {}) {
      const heads = { 'X-CCS-Last-Updated-At': this.orderDetail.lastUpdatedAt }
      let pathMethod
      switch (this.mode) {
        case define.ORDER_MODE.SHORTAGE:
          pathMethod = 'resend'
          break
        case define.ORDER_MODE.EXCHANGE:
          pathMethod = 'exchange'
          break
        case define.ORDER_MODE.RECEIVED:
          pathMethod = 'receive'
          break
        case define.ORDER_MODE.CAPTURE:
          pathMethod = 'capture'
          break
        case define.ORDER_MODE.CANCEL:
          pathMethod = 'cancel'
          break
        case define.ORDER_MODE.CHANGE_PAYMENT:
          pathMethod = 'changePayment'
          break
        case define.ORDER_MODE.EDIT:
        default:
          pathMethod = 'edit'
          break
      }
      const url = `${config.ORDER_URL}/${uuid}/${pathMethod}`
      const response = await common.apiAxios(url, { method: method, data: data, heads })
      return response
    },
    hasLastUpdatedError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }

      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'lastUpdatedAt' && val.reason === 'invalid')
        .value() != null
    },
    /**
     * 注文記録 API
     * @param {String} method post,put,delete
     * @param {String} uuid
     * @param {Object} data request body
     */
    async callApiOrderNote ({ method, uuid, data }) {
      const url = uuid ? config.ORDER_NOTE_URL + '/' + uuid : config.ORDER_NOTE_URL
      await common.apiAxios(url, { method: method, data: data })
    },
    /**
     * 注文記録
     * @param {String} method post,put,delete
     * @param {Object} data request body
     * @param {String} uuid
     */
    async orderNote ({ method, uuid, data }) {
      try {
        this.$loadingService.show()
        await this.callApiOrderNote({ method, uuid, data })
        // 削除以外は入力情報をクリアする
        if (method !== 'delete') {
          this.clearNote()
        }
        await this.getDetailData({ updateList: true })
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * collapse の 開閉状態を localStorage に保存します。
     */
    collapseChange: function () {
      common.setLocalStorage(this.activeCollapseKey, this.activeCollapseName.join())
      this.activeCollapseName = common.getLocalStorage(this.activeCollapseKey).split(',')
    },
    /**
     * 表示する注文情報（履歴）を移動します。
     * @param {Number} index 移動する数
     */
    moveOrderHistory: function (index) {
      this.orderIndex = this.orderIndex + Number(index)
      if (this.orderIndex > -1) {
        this.setOrderDetail(_.cloneDeep(this.originData.histories[this.orderIndex]))
      } else {
        this.setOrderDetail(_.cloneDeep(this.originData))
      }
    },
    /**
     * 一括取消を行います。
     */
    orderCancel: async function (fromList = false) {
      this.$confirm('注文を取消しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          if (!fromList) { // 一覧から来た場合は、initByModeからコールされて来ているため、スキップする
            this.updateMode(define.ORDER_MODE.CANCEL)
            await this.initByMode()
          }
          let isClearPoint = false
          if (this.orderPointConfigCancel === '1' &&
            (this.orderDetailItems.some(item => item.point > 0 || item.consumedPoint > 0) ||
            this.orderDetail.point > 0 || this.orderDetail.consumedPoint > 0)) {
            await this.$confirm('ポイントも 0 にしますか？', define.MESSAGE_TITLE, {
              confirmButtonText: 'はい',
              cancelButtonText: 'いいえ',
              type: 'warning'
            }).then(() => {
              isClearPoint = true
            }).catch(() => {})
          }
          await this.orderCancelUpdate(isClearPoint)
          const requestOrder = await this.buildOrderRequest()

          if (this.useMail && this.needConfirm) {
            await this.$confirm('キャンセルメールを送信しますか？', define.MESSAGE_TITLE, {
              confirmButtonText: 'はい',
              cancelButtonText: 'いいえ',
              type: 'warning'
            }).then(() => {
              requestOrder.sendMails = [{ mailType: define.MAIL_TYPE.CANCEL, isSend: 1 }]
            }).catch(() => {})
          } else if (this.useMail && !this.needConfirm) {
            requestOrder.sendMails = [{ mailType: define.MAIL_TYPE.CANCEL, isSend: 1 }]
          }

          await this.callApiOrderUpdate({ uuid: this.orderDetail.uuid, data: requestOrder })
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            if (this.hasLastUpdatedError(error)) {
              common.addError(error, { msg: message.MSG_521() })
            } else {
              common.addError(error, { msg: message.MSG_505() })
            }
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          await this.$_ConfirmDiscardOnLeave_watchEnd()
          await this.getDetailData({ updateList: true })
          this.originData = _.cloneDeep(this.orderDetail)
          this.changeModeToNormal()
          this.isChanged = false

          this.$loadingService.close()
        }
      }).catch(() => {
        this.cancel()
      })
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      // O-Plux
      if (mode === 'OPLUX') {
        this.onOpluxClick()
        return
      }
      try {
        await auth.tokenExpiredTransitionLogin()
        if (this.noteInfo.uuid) {
          await this.$alert('メモ修正中です。', define.MESSAGE_TITLE, {
            confirmButtonText: '閉じる'
          })
          return
        }
        // 編集可否チェック
        if (this.$_orderUtil_showOrderExportInProcessDialogIfNeed(this.orderDetail) ||
            this.$_orderUtil_showUneditableOrderPaymentDialogIfNeed(this.orderDetail)) {
          return
        }
        if (this.noTaxInfo) {
          this.$alert(
            '基本税率情報の取得に失敗したため、注文の修正は行えません。',
            define.MESSAGE_TITLE,
            { type: 'warning', showClose: false }
          )
          return true
        }
        switch (mode) {
          case define.ORDER_MODE.EDIT:
            this.changeMode(define.ORDER_MODE.EDIT)
            break
          case define.ORDER_MODE.SHORTAGE:
            this.changeMode(define.ORDER_MODE.SHORTAGE)
            break
          case define.ORDER_MODE.EXCHANGE:
            this.changeMode(define.ORDER_MODE.EXCHANGE)
            break
          case define.ORDER_MODE.RECEIVED:
            // 全出荷完了 + 未支払の場合は返品登録不可
            // if (this.$_orderUtil_isShippedAll(this.orderDetail.qty)) {
            //   if (this.orderDetail.isPaid === 0) {
            //     this.$alert('未決済の支払があるため、返品登録できません。', define.MESSAGE_TITLE, {
            //       confirmButtonText: '閉じる'
            //     });
            //     return;
            //   }
            // }
            this.changeMode(define.ORDER_MODE.RECEIVED)
            break
          case define.ORDER_MODE.CAPTURE:
            this.changeMode(define.ORDER_MODE.CAPTURE)
            break
          case define.ORDER_MODE.SHIPMENT:
            this.changeMode(define.ORDER_MODE.SHIPMENT)
            break
          case define.ORDER_MODE.CANCEL:
            this.orderCancel()
            break
          default:
        }
      } catch (error) {
        this.$log.error(error)
        throw error
      }
    },
    /**
     * 保存処理を実行します。
     */
    save: async function () {
      this.activeTabName = this.defaultDispTab
      this.$validator.validate().then(result => {
        if (result) {
          if (this.showValidateErrorDialogIfNeed()) {
            return
          }

          // 決済が作成される場合はメッセージを変更
          const meg = this.isCreatedCaputure ? `この金額で決済予約が作成されます。保存しますか？`
            : `保存しますか？`

          this.$confirm(meg, define.MESSAGE_TITLE, {
            confirmButtonText: 'はい',
            cancelButtonText: 'いいえ',
            type: 'warning'
          }).then(async () => {
            try {
              this.$loadingService.show()
              const requestOrder = await this.buildOrderRequest()
              await this.callApiOrderUpdate({ uuid: this.orderDetail.uuid, data: requestOrder })
              await this.$_ConfirmDiscardOnLeave_watchEnd()
              this.isChanged = false
              this.changeModeToNormal()
              await this.getDetailData({ updateList: true })
              this.$notify.success('保存しました。')
            } catch (error) {
              const data = _.get(error, 'response.data')
              if (data == null) {
                common.addError(error, { msg: message.MSG_502() })
              } else {
                if (this.hasLastUpdatedError(error)) {
                  common.addError(error, { msg: message.MSG_521() })
                } else {
                  common.addError(error, { msg: message.MSG_501() })
                }
              }
              this.$notify.error({ error: error })
              throw error
            } finally {
              this.$loadingService.close()
            }
          }).catch((reason) => {
            if (reason === 'cancel') {
              this.$notify.info('キャンセルしました。')
            }
          })
        } else {
          // エラー箇所を開く
          let set = new Set(this.activeCollapseName)
          document.querySelectorAll('.el-collapse-item').forEach(element => {
            if (element.querySelector('.is-error')) {
              set.add(element.id)
            }
          })
          this.activeCollapseName = Array.from(set)

          // 配送先のエラー箇所を開く
          _.chain(this.$refs)
            .get('OrderDetailShipment')
            .forEach(val => val.openErrorField())
            .value()

          // エラー発生個所へ移動
          setTimeout(function () {
            let error = document.querySelector('.is-error')
            if (error) {
              error.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
            }
          }, 200)
        }
      })
    },
    /**
     * 注文編集キャンセル
     */
    cancel: function () {
      const cancelEdit = () => {
        this.$_ConfirmDiscardOnLeave_watchEnd()
        this.changeModeToNormal()
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('変更を破棄しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        this.setOrderDetail(_.cloneDeep(this.originData))
        cancelEdit()
      })
    },
    /**
     * 編集内容をチェックして、エラーがある場合ダイアログを表示する
     * @returns {Boolean} ダイアログを表示した場合、true
     */
    showValidateErrorDialogIfNeed () {
      const message =
        this.getEditedDataErrorMessageByMode() ||
        this.getDuplicateSkuErrorMessage() ||
        this.getPartialShipmentErrorMessage() ||
        this.getOverFirstTotalAmountErrorMessage() ||
        this.getCanceledBasePriceErrorMessage() ||
        this.getAdjustmentPriceErrorIfMessage() ||
        this.getSubtotalErrorMessage() ||
        this.getTotalErrorMessage() ||
        ''
      if (message !== '') {
        this.$alert(
          message, define.MESSAGE_TITLE,
          { type: 'warning', showClose: false }
        )
        return true
      }
      return false
    },

    /**
     * データ未変更メッセージを取得する
     * @returns {String} エラーメッセージ. モードに伴った操作がされている場合、null
     */
    getEditedDataErrorMessageByMode () {

      // 変更前と変更後の差分を取得
      const changedData = compare.diff(this.originData, this.orderDetail)
      const items = _.chain(changedData)
        .get('shipments')
        .flatMap(val => _.values(val.items))
        .value()

      let message
      switch (this.mode) {
        // 明細、又はバンドル構成品の出荷キャンセル数に変更がなければ、メッセージ
        case define.ORDER_MODE.SHORTAGE:  // 再送
          message = _.filter(items, v => {
            return _.get(v, 'qty.unshipped') != null ||
              Object.values(v.bundleItems || {}).some((component) => {
                return _.get(component, 'qty.unshipped') != null
              })
          }).length > 0
            ? null : '再送の操作が行われていません。'
          break
        case define.ORDER_MODE.EXCHANGE:  // 交換
          // 明細、又はバンドル構成品の交換返品数に変更がなければ、メッセージ
          message = _.filter(items, v => {
            return _.get(v, 'qty.exIn') != null ||
              Object.values(v.bundleItems || {}).some((component) => {
                return _.get(component, 'qty.exIn') != null
              })
          }).length > 0
            ? null : '交換の操作が行われていません。'
          break
        case define.ORDER_MODE.RECEIVED:  // 返品
          // 明細、又はバンドル構成品の返品数に変更がなければ、メッセージ
          message = _.filter(items, v => {
            return _.get(v, 'qty.receiveFixed') != null ||
              Object.values(v.bundleItems || {}).some((component) => {
                return _.get(component, 'qty.receiveFixed') != null
              })
          }).length > 0
            ? null : '返品の操作が行われていません。'
          break
        default:
      }
      return message
    },

    /**
     * SKU重複エラーメッセージを取得する
     * @returns {String} エラーメッセージ. 同一配送先に同一SKUがない場合、null
     */
    getDuplicateSkuErrorMessage () {
      if (this.allowSameSku(this.siteCode) === '1') {
        return null
      }

      const found = _.chain(this.orderDetail)
        .get('shipments')
        .find(val => {
          const productIds = _.chain(val)
            .get('items')
            .map(val => val.productId)
            .value()
          return productIds.length !== _.uniq(productIds).length
        })
        .value()
      return found == null
        ? null
        : `同一配送先に同一SKUが含まれています。`
    },
    /**
     * 分出荷不可メッセージを取得する
     * @returns {String} エラーメッセージ. 分出荷可能な場合、null
     */
    getPartialShipmentErrorMessage () {
      if (this.allowPartialShipment(this.siteCode) === '1') {
        return null
      }
      const found = _.chain(this.orderDetail)
        .get('shipments')
        .find(val => {
          return _.chain(val)
            .get('items')
            .map('qty')
            .thru(val => {
              return (
                _.find(val, val => val.preExport > 0) ||
                _.find(val, val => val.preReExport > 0)
              ) &&
              (
                _.find(val, val => val.unallocated > 0) ||
                _.find(val, val => val.pending > 0) ||
                _.find(val, val => val.unshipped > 0)
              )
            })
            .value()
        })
        .value()
      return found == null
        ? null
        : `一部出荷したい場合は先にキャンセル処理を行ってください。`
    },
    /**
     * 初回注文金額超過警告メッセージを取得する
     * @returns {String} エラーメッセージ. 初回注文金額超過していない場合、null
     */
    getOverFirstTotalAmountErrorMessage () {
      if (this.allowOverFirstTotalAmount(this.siteCode) === '1') {
        return null
      }

      const firstTotal = _.chain(this.originData)
        .get('histories')
        .last()
        .thru(val => val || this.originData)
        .get('orderTotalPrice.gross')
        .value()
      return firstTotal == null || +firstTotal >= +this.orderDetail.orderTotalPrice.gross
        ? null
        : `現在の総合計が、初回注文時の総合計(${Number(firstTotal)}円)を超えています。`
    },
    /**
     * キャンセル商品単価変更エラーメッセージを取得する
     * @returns {String} エラーメッセージ. キャンセル商品単価変更していない場合、null
     */
    getCanceledBasePriceErrorMessage () {
      const current0 = _.filter(this.orderDetailItems,
        val => val.uuid && Number(_.get(val, 'qty.current')) === 0)
      const found = _.chain(this.originData)
        .get('shipments')
        .flatMap(val => val.items)
        .filter(val => val != null && val.delete !== 1)
        .find(val => {
          return _.find(current0, cur => {
            return val.uuid === cur.uuid &&
              (Number(_.get(val, 'basePrice.net')) !== Number(_.get(cur, 'basePrice.net')) ||
                Number(_.get(val, 'basePrice.gross')) !== Number(_.get(cur, 'basePrice.gross')))
          }) != null
        })
        .value()
      return found == null
        ? null
        : `数量が0の明細の単価は変更できません。`
    },
    /**
     * 単品値引エラーメッセージを取得する
     * @returns {String} エラーメッセージ. 単品値引にエラーがない場合、null
     */
    getAdjustmentPriceErrorIfMessage () {
      const found = _.chain(this.orderDetail)
        .get('shipments')
        .flatMap(val => _.concat([], val.items, val.giftItems, val.shippingItems))
        .filter(val => val != null && val.delete !== 1)
        .find(val => {
          const priceAdjustments = _.chain(val.priceAdjustments)
            .filter(val => val != null && val.delete !== 1)
            .map(val => _.get(val, 'price.gross', 0))
            .value()
          const adjustedGross = math.add(
            _.concat([], _.get(val, 'price.gross', 0), priceAdjustments)
          )
          return adjustedGross < 0
        })
        .value()
      return found == null
        ? null
        : `調整後の金額が0円未満になっている明細があります。`
    },
    /**
     * 小計エラーメッセージを取得する
     * @returns {String} エラーメッセージ. 小計にエラーがない場合、null
     */
    getSubtotalErrorMessage () {
      const itemsGross = _.chain(this.orderDetailItems)
        .flatMap(val => _.concat([], val, val.priceAdjustments))
        .filter(val => val != null && val.delete !== 1)
        .map(val => _.get(val, 'price.gross'))
        .filter(val => val != null && val !== '')
        .thru(val => math.add(val))
        .value()
      const merchandisePriceAdjustmentsGross = _.chain(this.orderDetail)
        .get('merchandisePriceAdjustments')
        .filter(val => val != null && val.delete !== 1)
        .map(val => _.get(val, 'price.gross'))
        .filter(val => val != null && val !== '')
        .thru(val => math.add(val))
        .value()
      const subtotal = math.add([itemsGross, merchandisePriceAdjustmentsGross])
      return subtotal >= 0
        ? null
        : `商品合計金額以上の小計値引を入力することはできません。`
    },
    /**
     * 総合計エラーメッセージを取得する
     * @returns {String} エラーメッセージ. 総合計にエラーがない場合、null
     */
    getTotalErrorMessage () {
      return Number(_.get(this.orderDetail, 'orderTotalPrice.gross')) >= 0
        ? null
        : `総合計金額を0円未満にすることはできません。`
    },
    /**
     * メモクリア
     */
    clearNote () {
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.noteInfo.subject = ''
      this.noteInfo.note = ''
      this.noteInfo.uuid = ''
      this.noteInfo.changingNoteNumber = null
    },
    /**
     * メモ編集
     */
    editNote (row, index) {
      this.$_ConfirmDiscardOnLeave_watchStart(this.noteInfo, '編集中のメモを破棄しますか？')
      this.noteInfo.subject = row.subject
      this.noteInfo.note = row.note
      this.noteInfo.uuid = row.uuid
      this.noteInfo.changingNoteNumber = index + 1
    },
    /**
     * メモ保存
     */
    saveNote () {
      this.$confirm(
        this.noteInfo.uuid
          ? `No.${this.noteInfo.changingNoteNumber}を修正しますか？`
          : 'メモを追加しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(async () => {
        try {
          const data = {
            siteCode: this.orderDetail.site.code,
            orderNo: this.orderDetail.orderNo,
            subject: this.noteInfo.subject,
            note: this.noteInfo.note,
            noteType: this.noteInfo.noteType
          }
          const uuid = this.noteInfo.uuid || null
          const method = this.noteInfo.uuid ? 'put' : 'post'
          await this.orderNote({ method: method, data: data, uuid: uuid })
          this.$_ConfirmDiscardOnLeave_watchEnd()
        } catch (error) {
          common.addError(error, { msg: message.MSG_508({ method: this.noteInfo.uuid ? '更新' : '登録' }) })
          this.$notify.error({ error: error })
          throw error
        }
      }).catch((reason) => {
        if (reason === 'cancel') {
          this.$notify.info('キャンセルしました。')
        }
      })
    },
    /**
     * メモ削除
     */
    deleteNote (row, index) {
      this.$confirm(`No.${index + 1}を削除しますか？`, define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          const method = 'delete'
          await this.orderNote({ method: method, uuid: row.uuid })
        } catch (error) {
          common.addError(error, { msg: message.MSG_508({ method: '削除' }) })
          this.$notify.error({ error: error })
          throw error
        }
      }).catch((reason) => {
        if (reason === 'cancel') {
          this.$notify.info('キャンセルしました。')
        }
      })
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },
    showConfirmAllShortageShip () {
      this.$confirm('出荷キャンセルをすべて再送指図待ちしますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        _.chain(this.orderDetailItems)
          .filter(val => _.get(val, 'qty.unshipped', 0) > 0)
          .forEach(val => {
            this.$_orderUtil_moveQty(val.qty, val.qty, [ 'unshipped' ], 'preReExport')
            val.qty.current = this.$_orderUtil_calculateCurrentQty(val.qty)
            // バンドル商品の場合
            if (val.isBundle) {
              _.forEach(val.bundleItems, bVal => {
                this.$_orderUtil_moveQty(bVal.qty, bVal.qty, [ 'unshipped' ], 'preReExport')
                bVal.qty.current = this.$_orderUtil_calculateCurrentQty(bVal.qty)
              })
            }
          })
          .value()
      }).catch(() => {})
    },
    validateOrderInfo () {
      this.$validator.validate('orderInfo.*')
    },
    /**
     * O-Pluxボタンクリック
     */
    onOpluxClick () {
      // データをセット
      this.opluxData.node = _.pick(this.orderDetail, ['uuid', 'lastUpdatedAt', 'redResult', 'attributes'])
      // モーダル表示
      this.isOpluxDialog = true
    },
    /**
     * ポイント支払、又はポイント値引の変更
     */
    detailPointChange (amount, type) {
      // 消費ポイント自動計算設定
      const autoCalcVal = this.getOrderPointConfig(this.siteCode, 'auto_calc')

      // 設定が存在しない、又は値1が 0 の場合、処理を終了
      if (autoCalcVal !== '1') {
        return false
      }

      // 消費ポイント区分
      const pointType = this.getOrderPointConfig(this.siteCode, 'point_type')
      // 設定が存在しない場合、又は値1に以下以外の値が設定されている場合、エラーを表示し、処理を終了
      if ((type === 'pointPay' && pointType !== '1') ||
        (type === 'priceAdj' && pointType !== '2')) {
        this.$notify.error({
          message: '消費ポイント区分が不正です。'
        })
        return false
      }

      // 値1の設定によって、メッセージを出し分ける
      this.$confirm('消費ポイントに反映しますか？', define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
        // 消費ポイント基本レート
        const basicRate = this.getOrderPointConfig(this.siteCode, 'basic_rate')

        // 基本レートが存在しない場合、処理を終了
        if (!basicRate) {
          this.$notify.error({
            message: '消費ポイント基本レート不正です。'
          })
          return false
        }

        // 値1の設定値で金額を算出して、消費ポイントに設定する
        // 計算式：(ポイント支払金額 or ポイント値引金額) / 消費ポイント基本レート
        this.$set(this.orderDetail, 'consumedPoint', Math.floor(amount / basicRate))
      }).catch(() => {})
    },
    /**
     * 消費ポイントの変更
     */
    consumedPointChange (point) {
      this.watchFlg = false
      // 消費ポイント自動計算設定
      const autoCalcVal = this.getOrderPointConfig(this.siteCode, 'auto_calc')
      // 設定が存在しない、又は値1が 0 の場合、処理を終了
      if (autoCalcVal !== '1') {
        return false
      }
      // 消費ポイント区分
      const pointType = this.getOrderPointConfig(this.siteCode, 'point_type')
      // 設定が存在しない場合、又は値1に以下以外の値が設定されている場合、エラーを表示し、処理を終了
      if (pointType !== '1' && pointType !== '2') {
        this.$notify.error({
          message: '消費ポイント区分が不正です。'
        })
        return
      }
      // 値1の設定によって、メッセージを出し分ける
      this.$confirm(pointType === '1'
        ? 'ポイント支払金額に反映しますか？'
        : 'ポイント値引金額に反映しますか？',
      define.MESSAGE_TITLE,
      {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        // 消費ポイント基本レート
        const basicRate = this.getOrderPointConfig(this.siteCode, 'basic_rate')

        // 基本レートが存在しない場合、処理を終了
        if (!basicRate) {
          this.$notify.error({
            message: '消費ポイント基本レート不正です。'
          })
          return
        }

        // 値1の設定値で金額を算出
        // 計算式：消費ポイント x 消費ポイント基本レート
        const amount = Math.floor(point * basicRate)

        // 反映対象オブジェクト
        let changeTarget
        // 対象リストにisPoint=1の件数
        let isPointLength
        // isPoint=1のインデックス（一件のみ使用）
        let isPointIndex
        // 値1が1(支払)の場合
        if (pointType === '1') {
          changeTarget = this.orderDetail.payments
          isPointLength = _.filter(changeTarget, { paymentMethod: { isPoint: 1 } }).length
          isPointIndex = _.findIndex(changeTarget, { paymentMethod: { isPoint: 1 } })
        } else {
          changeTarget = this.orderDetail.merchandisePriceAdjustments
          isPointLength = _.filter(changeTarget,
            val => !val.delete && val.isPoint === 1).length
          isPointIndex = _.findIndex(changeTarget,
            val => !val.delete && val.isPoint === 1)
        }
        // isPoint=1のレコードが１件以上存在する場合
        if (isPointLength > 1) {
          this.$notify.error({
            message:
              (pointType === '1' ? '支払方法内訳にポイント支払' : 'ポイント値引') + 'が複数存在するため、自動計算できません。'
          })
          return false
        } else if (isPointLength === 1) {
          // isPoint=1のレコードが1件だけ存在する場合
          if (amount === 0 && !_.has(changeTarget[isPointIndex], 'uuid')) {
            // 算出金額が 0 の場合、uuid が存在しない(DB未登録)であれば、該当データを削除
            changeTarget.splice(isPointIndex, 1)
          } else if (amount !== 0 || _.has(changeTarget[isPointIndex], 'uuid')) {
            // 金額が 0 以外、又は uuid が存在する(DB登録済み)であれば、算出した金額を反映
            if (pointType === '1') {
              // 支払の場合
              this.$set(changeTarget[isPointIndex], 'amount', amount)
            } else {
              // 値引の場合
              this.$set(changeTarget[isPointIndex].basePrice, 'gross', amount)
              this.$set(changeTarget[isPointIndex].price, 'gross', amount)
            }
          }
        } else {
          // isPoint=1のレコードが存在しない場合
          if (amount === 0) {
            // 算出金額が 0 の場合、処理を終了
            return false
          } else {
            // 金額が 0 以外の場合、小計値引(注文調整金額)またはポイント支払に追加し
            if (pointType === '1') {
              // 支払の場合
              const paymentMethod = _.filter(_.filter(this.sites,
                { code: this.siteCode })[0].paymentMethods, (v) => { return v.isPoint === 1 })[0]
              changeTarget.push({
                paymentMethod: {
                  code: paymentMethod.code, // 決済種別
                  name: paymentMethod.name, // 決済名
                  isPoint: 1 // ポイント区分
                },
                amount: amount, // 算出した金額
                isPaid: this.orderDetail.isPaid, // 注文の is_paid と同値を設定する
                isProcessed: 1, // 支払処理対象
                readonly: true // 連動で追加されたレコードの支払方法は変更不可
              })
            } else {
              // 値引の場合
              // プロモーションID
              const promotionId = this.getPointAdjustmentConfig(this.siteCode, 'promotion_id')
              // キャンペーンID
              const campaignId = this.getPointAdjustmentConfig(this.siteCode, 'campaign_id')
              // クーポンID
              const couponId = this.getPointAdjustmentConfig(this.siteCode, 'coupon_id')
              // 表示名称
              const lineitemText = this.getPointAdjustmentConfig(this.siteCode, 'lineitem_text')
              changeTarget.push({
                promotionId: promotionId || '', // プロモーションID
                campaignId: campaignId || '', // キャンペーンID
                couponId: couponId || '', // クーポンID
                reasonCode: '', // 理由コード
                lineitemText: lineitemText || '', // 表示名称
                basePrice: { net: 0, gross: amount }, // 調整単価
                price: { net: 0, gross: amount }, // 調整金額
                isPoint: 1 // ポイントフラグ
              })
              // 総合計再計算
              this.calculateTotal()
            }
          }
        }
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetailTop.vue